import React from 'react';

export const Home = () => {
    return (
        <div>
            <h1>WeatherBug Auth.Identity Server</h1>
            <p>Welcome to the WeatherBug Authentication server.</p>
        </div>
    );
};
